// Variant Specifications Dynamic Updater
// 仅在使用variant metafields时才更新规格表
class VariantSpecificationsUpdater {
  constructor() {
    this.specificationsBlock = document.querySelector('.specifications-block');
    this.productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    this.init();
  }

  init() {
    if (!this.specificationsBlock) return;
    this.observeVariantChanges();
  }

  observeVariantChanges() {
    // 监听variant选择器变化
    const variantSelectors = document.querySelectorAll('variant-radios, variant-selects');
    
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        setTimeout(() => {
          this.checkAndUpdateSpecs();
        }, 100);
      });
    });

    // 监听表单中的variant input变化
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      const observer = new MutationObserver(() => {
        this.checkAndUpdateSpecs();
      });
      
      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    // 监听URL变化
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        this.checkAndUpdateSpecs();
      }
    }).observe(document, {subtree: true, childList: true});
  }

//  checkAndUpdateSpecs() {
//    const currentVariantId = this.getCurrentVariantId();
//    const blockVariantId = this.specificationsBlock?.dataset.variantSpecs;
    
//    if (currentVariantId && blockVariantId && currentVariantId !== blockVariantId) {
//      this.reloadSpecificationsSection(currentVariantId);
//    }
//  }

    checkAndUpdateSpecs() {
      const currentVariantId = this.getCurrentVariantId();
      
      if (!currentVariantId) {
        console.log('❌ No variant ID found');
        return;
      }
      
      const blockVariantId = this.specificationsBlock?.dataset.variantSpecs;
      
      // 只在 variant 真的改变时才更新
      if (currentVariantId === blockVariantId) {
        console.log('ℹ️ Same variant, skipping update');
        return;
      }
      
      console.log(`🔄 Updating specs: ${blockVariantId} → ${currentVariantId}`);
      this.reloadSpecificationsSection(currentVariantId);
    }


  getCurrentVariantId() {
    const urlParams = new URLSearchParams(window.location.search);
    let variantId = urlParams.get('variant');
    
    if (!variantId) {
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        const variantInput = form.querySelector('[name="id"]');
        variantId = variantInput?.value;
      }
    }
    
    return variantId;
  }

//  reloadSpecificationsSection(variantId) {
//    const sectionId = this.specificationsBlock.closest('[data-section-id]')?.dataset.sectionId;
//    if (!sectionId) {
//      const url = new URL(window.location);
//      url.searchParams.set('variant', variantId);
//      window.history.replaceState({}, '', url);
//      // location.reload();
//      return;
//    }

//    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
    
//    fetch(url)
//      .then(response => response.text())
//      .then(html => {
//        const parser = new DOMParser();
//        const doc = parser.parseFromString(html, 'text/html');
//        const newSpecBlock = doc.querySelector('.specifications-block');
        
//        if (newSpecBlock && this.specificationsBlock) {
//          const wasOpen = this.specificationsBlock.querySelector('.about__accordion-toggle').classList.contains('active');
          
//          this.specificationsBlock.innerHTML = newSpecBlock.innerHTML;
//          this.specificationsBlock.dataset.variantSpecs = variantId;
          
//          if (wasOpen) {
//            const toggle = this.specificationsBlock.querySelector('.about__accordion-toggle');
//            const description = this.specificationsBlock.querySelector('.about__accordion-description');
//            if (toggle && description) {
//              toggle.classList.add('active');
//              description.style.display = 'block';
//            }
//          }
//        }
//      })
//      .catch(error => console.error('Error reloading specifications:', error));
// }

reloadSpecificationsSection(variantId) {
  console.log('🔄 Starting reload for variant:', variantId);
  
  let sectionId = this.specificationsBlock.closest('[data-section-id]')?.dataset.sectionId;
  console.log('📦 Section ID:', sectionId);
  
  if (!sectionId) {
    console.log('⚠️ No section ID found, trying alternative method...');
    // 尝试从其他地方获取 section ID
    const mainProduct = document.querySelector('.product');
    sectionId = mainProduct?.dataset.sectionId || mainProduct?.closest('[id^="shopify-section"]')?.id.replace('shopify-section-', '');
    console.log('📦 Alternative section ID:', sectionId);
    
    if (!sectionId) {
      console.log('❌ Cannot find section ID, reloading page instead');
      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.location.href = url.toString();
      return;
    }
  }

  const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
  console.log('🌐 Fetching URL:', url);
  
  fetch(url)
    .then(response => {
      console.log('📥 Response status:', response.status);
      return response.text();
    })
    .then(html => {
      console.log('📄 HTML received, length:', html.length);
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSpecBlock = doc.querySelector('.specifications-block');
      
      console.log('🔍 New spec block found:', !!newSpecBlock);
      
      if (newSpecBlock && this.specificationsBlock) {
        const wasOpen = this.specificationsBlock.querySelector('.about__accordion-toggle')?.classList.contains('active');
        console.log('📂 Was open:', wasOpen);
        
        // 更新内容
        this.specificationsBlock.innerHTML = newSpecBlock.innerHTML;
        this.specificationsBlock.dataset.variantSpecs = variantId;
        
        console.log('✅ Content updated');
        
        // 恢复打开状态
        if (wasOpen) {
          const toggle = this.specificationsBlock.querySelector('.about__accordion-toggle');
          const description = this.specificationsBlock.querySelector('.about__accordion-description');
          if (toggle && description) {
            toggle.classList.add('active');
            description.style.display = 'block';
            console.log('📂 Restored open state');
          }
        }
      } else {
        console.log('❌ Could not find new spec block in response');
        console.log('Response preview:', html.substring(0, 500));
      }
    })
    .catch(error => {
      console.error('❌ Error reloading specifications:', error);
    });
}

}

// 初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new VariantSpecificationsUpdater();
  });
} else {
  new VariantSpecificationsUpdater();
}
